export const PRIMARY_CONTACT_ORG_ROLE_NAME = 'Primary Contact';

const LearnToSwimConstants = {
  PRIMARY_CONTACT_ORG_ROLE_NAME
};

export default LearnToSwimConstants;